import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const updateCursusStageFlags = (
  language: string,
  cursusStageId: number,
  flagIds: number[],
  setIsSaving: Function,
  successCallback?: Function
) => {
  setIsSaving(true);
  ApiService.put(`cursus/stages/${cursusStageId}/flags`, { flag_ids: flagIds })
    .then((_) => {
      alert(translate(language, "PAGES.COURSE.MODALS.EDIT_FLAGS.ALERTS.SUCCESS"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error updating cursus stage flags", error);
      alert(translate(language, "PAGES.COURSE.MODALS.EDIT_FLAGS.ALERTS.ERROR"));
    })
    .finally(() => setIsSaving(false));
};

export const fetchFlags = (language: string, setFlags: Function, setIsFlagsLoading: Function) => {
  setIsFlagsLoading(true);
  ApiService.get("flags")
    .then((resp) => setFlags(resp.data.flags))
    .catch((error) => {
      console.error("Error fetching flags", error);
      alert(translate(language, "PAGES.COURSE.MODALS.EDIT_FLAGS.ALERTS.FETCH_FLAGS_ERROR"));
    })
    .finally(() => setIsFlagsLoading(false));
};
